import React, { useState, useEffect } from "react";
import { formatCurrency } from "../../utils/CommonFunctions";
import {
  MyCancelIcon,
  MyDoNotDisturbOnIcon,
  MyHourglassEmptyIcon,
  MyReceiptLongIcon,
  MyRefreshIcon,
  MyTaskAltIcon,
  MyWifiIcon,
  MyWifiOffIcon,
} from "../../Assets/svg/MyIcons";

const DashboardStatsCards = ({
  cardType, 
  globalKpiData,
  hasTransactionPermission,
  showButton,
  onRemove,
}) => {
  const [kpiData, setKpiData] = useState({ amount: "0.00", count: "0" });

  const cardConfig = {
    totalTransactionAmount: {
      icon: MyReceiptLongIcon,
      label: "Total Transactions",
      color: "primary",
      permission: hasTransactionPermission?.canView,
    },
    totalOnlineTransaction: {
      icon: MyWifiIcon,
      label: "Online Payments",
      color: "info",
      permission: hasTransactionPermission?.canView,
    },
    totalOfflineTransaction: {
      icon: MyWifiOffIcon,
      label: "Offline Payments",
      color: "dark",
      permission: hasTransactionPermission?.canView,
    },
    totalSuccessfulTransactions: {
      icon: MyTaskAltIcon,
      label: "Successful",
      color: "success",
      permission: hasTransactionPermission?.canView,
    },
    totalPendingTransactions:{
      icon: MyHourglassEmptyIcon,
      label: "Pending",
      color: "warning",
      permission: hasTransactionPermission?.canView,
    },
    totalRefundTransactions: {
      icon: MyRefreshIcon,
      label: "Refund",
      color: "primary",
      permission: hasTransactionPermission?.canView,
    },
    totalFailedTransactions: {
      icon: MyDoNotDisturbOnIcon,
      label: "Failed",
      color: "danger",
      permission: hasTransactionPermission?.canView,
    },
  };

  const config = cardConfig[cardType];

  useEffect(() => {
    if (globalKpiData && globalKpiData[cardType]) {
      setKpiData(globalKpiData[cardType] || { amount: "0.00", count: "0" });
    }
  }, [globalKpiData, cardType]);

  if (!config || !config.permission) return null;

  const IconComponent = config.icon;
  const color = config.color;

  return (
    <div className={`card ${!showButton && "my-3"}`}>
      {showButton && (
        <MyCancelIcon
          className="close-icon position-absolute cursor-pointer dash-close z-index-3"
          style={{ top: 5, right: 5 }}
          onClick={() => onRemove(cardType)}
        />
      )}

      <div className="card-body d-flex justify-content-between align-items-start flex-column p-5">
        <div className="d-flex justify-content-between align-items-center w-100 mb-7">
          <div
            className={`symbol symbol-55px w-55px h-55px border d-flex justify-content-center align-items-center rounded-circle bg-${color}  bg-opacity-15   text-${color}/20`}
          >
            <IconComponent size={30} />
          </div>
          <div className="d-flex align-items-center">
            {kpiData.count !== undefined && <div className="text-primary fs-1 fw-bold me-7 mt-2">{kpiData.count}</div>}
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="fw-normal text-gray-600 fs-4">{config.label}</div>
          <div className="fs-2 pt-1 fw-bold text-black">{formatCurrency(kpiData.amount || 0)}</div>
        </div>
      </div>
    </div>
  );
};

export default DashboardStatsCards;